export enum FilterValueKey {
    startDate = 'startDate',
    endDate = 'endDate',
}

export interface SidebarToggleProps {
    showSidebar: boolean;
    toggleSidebar: () => void;
}

export interface SavedValuesProps<V> {
    saveValues: (values: V) => void;
}
